export default {
    getTags({commit, state}) {
        $.ajax({
            url: '/media/tags/list',
            method: 'GET',
            global: false
        })
        .done((data) => {
            commit('updateTags', data);
        })
        .fail((xhr) => {
            console.error('something went wrong', xhr);
        });
    }
}